//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import _ from 'underscore';

import '../collection-items-bulk-add-menu/collection-items-bulk-add-menu';
import template from './bulk-actions-add-to-collection-modal.html';

export class BulkActionsAddToCollectionModal {
  public selectedCollections: any;
  public collections: any[];
  private onComplete;

  public submit() {
    const collectionIds = _(this.selectedCollections).keys();
    this.onComplete({ collectionIds });
  }

  public isCollectionSelected() {
    if (!this.selectedCollections) { return false; }

    return Object.keys(this.selectedCollections).length > 0;
  }
}

angular.module('curalate').component('bulkActionsAddToCollectionModal', {
  bindings: {
    onCancel: '&',
    onComplete: '&',
  },
  template,
  controller: [
    BulkActionsAddToCollectionModal,
  ],
});
